<template>
  <div v-if="recentOrders.length > 0">
    <div class="space-y-4">
      <RecentOrder
        v-for="recentOrder in recentOrders"
        :key="recentOrder.uuid"
        :recent-order="recentOrder"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import RecentOrder from '@menu/Shared/RecentOrder.vue';
import getSharedData from '@menu/Utils/getSharedData';
import { onMounted, ref } from 'vue';
import { RecentOrderResource } from '@menu/Types/Resources/RecentOrderResource';

import getVisitorUuid from '@menu/Utils/getVisitorUuid';
import getRestaurant from '@menu/Utils/getRestaurant';

const restaurant = getRestaurant();

const recentOrders = ref<RecentOrderResource[]>([]);

const loadRecentOrders = () => {
  if (!getSharedData().isOrderMode) {
    return;
  }

  axios
    .get('/api/orders', {
      params: {
        restaurantId: restaurant.id,
        visitorUuid: getVisitorUuid(),
      },
    })
    .then((res) => {
      recentOrders.value = res.data.data;
    })
    .catch(() => {
      //
    });
};

onMounted(loadRecentOrders);
</script>
